import { useFormContext } from "react-hook-form";

import BorderStyleColor from "containers/admin/clients/client/theme-page/preview/sub-tabs/button/components/border-style/secondary-inputs/border-style-color";
import ThemeInputNumber from "containers/admin/clients/client/theme-page/preview/components/theme-input-number/theme-input-number";

import { useButtonContent } from "containers/admin/clients/client/theme-page/preview/sub-tabs/button/use-button-content";

import {
  NONE_VALUE,
  BORDER_STYLE,
  WIDTH_VALUE,
} from "containers/admin/clients/client/theme-page/preview/sub-tabs/button/button.constants";

const BorderStyle = () => {
  const { watch } = useFormContext();
  const { arrowHelper, handleCustomChange, handleKeyDown } = useButtonContent();
  const borderStyleValue = watch(`button.${BORDER_STYLE}`)?.name?.value;

  if (borderStyleValue === NONE_VALUE) {
    return null;
  }

  return (
    <div className="flex flex-col gap-4">
      <BorderStyleColor />
      <ThemeInputNumber
        name={`button.${BORDER_STYLE}.width`}
        label="Border width (px)"
        onValueChange={(value, onChange) =>
          handleCustomChange(value, BORDER_STYLE, WIDTH_VALUE, onChange)
        }
        minValue={0}
        onArrowUp={(field) => arrowHelper(field, 1)}
        onArrowDown={(field) => arrowHelper(field, -1)}
        onKeyDown={handleKeyDown}
      />
    </div>
  );
};

export default BorderStyle;
